import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import _ from "lodash"
import Search from "../search/index"

const BlogSideBar = ({ categories, tags }) => {
  const pageQuery = graphql`
    query {
      allContentfulBlogPost(
        limit: 5
        sort: { fields: publishDate, order: DESC }
      ) {
        edges {
          node {
            slug
            tags
            title
            publishDate(formatString: "DD MMMM, YYYY")
            blogImage {
              fluid(maxWidth: 120) {
                src
              }
            }
            body {
              childMarkdownRemark {
                excerpt
                html
              }
            }
            category {
              name
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(pageQuery)
  const posts = data.allContentfulBlogPost.edges

  const searchIndices = [
    { name: `Posts`, title: `Blog Posts`, hitComp: `PostHit` },
  ]

  return (
    <div className="col-lg-3 mt-sm-30">
      {/* <div className="sidebar-widget">
        <h5>Search</h5>
        <Search indices={searchIndices} />
      </div> */}
      <div className="sidebar-widget">
        <h5>Categories</h5>
        <hr />
        <ul className="categories">
          {categories &&
            Object.keys(categories).map(category => (
              <li>
                <Link to={`/blog/category/${_.kebabCase(category)}`}>
                  {category} ({categories[category]})
                </Link>
              </li>
            ))}
        </ul>
      </div>
      <div className="sidebar-widget">
        <h5>Recent Posts</h5>
        <hr />
        <ul className="widget-post pt-15">
          {posts &&
            posts.map((post, index) => (
              <li key={index}>
                {/* <a className="widget-post-media">
                  <Img fluid={post.node.blogImage.fluid} alt={post.title} />
                </a> */}
                <div className="widget-post-info">
                  <h6>
                    <Link to={`/blog/${post.node.slug}`}>
                      {post.node.title}
                    </Link>
                  </h6>
                  <div className="post-meta">
                    <span>{post.node.publishDate}</span>
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
      <div className="sidebar-widget">
        <h5>Tags</h5>
        <hr />
        <ul className="widget-tag pt-15">
          {tags &&
            Object.keys(tags).map(tag => (
              <ul>
                <li>
                  <Link to={`/blog/tag/${_.kebabCase(tag)}`}>
                    {tag} ({tags[tag]})
                  </Link>
                </li>
              </ul>
            ))}
        </ul>
      </div>
    </div>
  )
}

export default BlogSideBar
